export const FIND_WALLET = 'WALLET/find_wallet';
export const VIEW_WALLET_LOGS = 'WALLET/view_wallet_logs';
export const UPDATE_WALLET_ROLLBACK = 'WALLET/update_wallet_logs';
export const VIEW_WALLET_LOGS_FOR_TXNID = 'WALLET/view_wallet_logs_for_txnid';
export const UPDATE_WALLET_TXN_ID = 'WALLET/update_wallet_txn_id';
export const CASH_OUT = 'WALLET/request_cashout'